<template>
  <!-- START : Wallet card with card image, brand, expiration, default and delete options -->
  <div class="card-body">
    <div class="card-title">
      <font-awesome-icon size="lg" :icon="faIcon" />
      <b class="ml-2">{{ brandDisplayName }} </b> *{{ token.finalDigits }}
    </div>
    <small v-if="token.expiration" class="d-block mb-2" :class="isTokenExpired && 'text-danger'">{{
      token.expiration | expiration
    }}</small>
    <button
      type="button"
      class="btn btn-primary btn-block default-card"
      :disabled="token.defaultToken"
      @click="onClickDefaultCard(token)"
    >
      {{ token.defaultToken ? 'Default' : 'Make Default' }}
    </button>
    <button
      type="button"
      class="btn btn-outline-primary btn-block delete-card"
      @click="onClickDeleteCard(token)"
      ref="modalTriggerButton"
    >
      <font-awesome-icon icon="trash" class="mr-1" /> {{ $t('deleteCard') }}
    </button>
  </div>
  <!-- END : Wallet card with card image, brand, expiration, default and delete options -->
</template>

<script>
import WalletFilters from '../../filters/WalletFilters';

export default {
  name: 'WCDesktopWalletCard',
  emits: ['makeDefault', 'deleteToken'],
  props: {
    token: {
      type: Object,
    },
    faIcon: {
      type: Array,
    },
    brandDisplayName: {
      type: String,
    },
    tokenExpiration: {
      type: String,
    },
    isTokenExpired: {
      type: Boolean,
    },
  },
  mixins: [WalletFilters], // WalletFilters for expiration format
  methods: {
    onClickDefaultCard(token) {
      this.$emit('makeDefault', token);
    },
    onClickDeleteCard(token) {
      this.$emit('deleteToken', token);
    },
  },
};
</script>
